import { CopyEmailButton } from "@/components/common/copy-email-button";
import { ModalWrapper } from "@/components/modals/modal-wrapper";
import {
  CONTACT_EMAIL,
  CONTACT_HOURS,
  CONTACT_PHONE,
} from "@/constants/contact";
import { popModal } from "@/stores/modal";
import { Button } from "@/styles/ui/button";

export const ContactModal = () => {
  return (
    <ModalWrapper className="flex flex-col items-start w-[374px] min-w-[190px] rounded-lg p-6 bg-white shadow-sm border border-neutral-200 gap-1.5">
      <div className="flex flex-col space-y-2 text-left items-center">
        <h2 className="body-1-normal-semibold text-primary">고객 센터</h2>
      </div>
      <div className="flex flex-col items-start gap-6 self-stretch">
        <div className="flex flex-col items-start gap-3 self-stretch">
          <span className="label-1-normal-regular text-neutral-500">
            전화 상담을 통해 더 빠른 지원을 받으실 수 있습니다.
            <br />
            유선 번호 : <span className="font-semibold">{CONTACT_PHONE}</span>
            <br />
            운영시간 : <span className="font-semibold">{CONTACT_HOURS}</span>
          </span>
          <span className="label-1-normal-regular text-neutral-500">
            이메일 문의 :{" "}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="font-semibold text-primary underline underline-offset-2"
            >
              {CONTACT_EMAIL}
            </a>
            <CopyEmailButton className="ml-1 align-middle text-neutral-400 hover:text-neutral-600" />
          </span>
        </div>
        <Button
          className="w-full h-9 py-2 px-4 justify-center items-center rounded-md bg-neutral-900"
          onClick={() => {
            popModal();
          }}
        >
          확인
        </Button>
      </div>
    </ModalWrapper>
  );
};
